var _rect, _polygon, _path, _path2, _polygon2, _polygon3, _path3, _polygon4, _path4, _path5, _rect2, _path6, _circle, _path7, _circle2, _path8, _circle3, _path9, _circle4, _path10, _circle5, _path11, _circle6, _path12, _circle7, _path13, _circle8, _path14, _circle9, _path15, _circle10, _path16, _path17, _path18, _path19, _rect3, _path20, _path21, _path22, _circle11, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle12, _path31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoneShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 704.72644,
    height: 560.95591,
    viewBox: "0 0 704.72644 560.95591",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 159.70342,
    y: 191.73569,
    width: 5,
    height: 55,
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "270.438 559.992 73.438 559.992 73.658 537.104 73.678 535.114 75.438 355.992 269.438 355.992 269.688 407.738 269.698 409.728 270.438 559.992",
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M756.00562,339.98873,787.882,285.95008a10.12678,10.12678,0,0,0-3.48087-13.77487l0,0a10.12679,10.12679,0,0,0-14.17886,3.86527l-31.39087,57.148-20.53808,33.92122a8.83707,8.83707,0,1,0,7.55813,8.45613Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M786.352,299.89063h0a2.98619,2.98619,0,0,0,2.2983-2.79656,3.87391,3.87391,0,0,1,.84492-2.207,3.56246,3.56246,0,0,1,.31968-.34128,5.84262,5.84262,0,0,0,1.91345-5.05186c-.4101-3.06825.69794-6.62582,2.05676-9.56381,1.48695-3.21492,3.17044-6.39758,3.84457-9.875.97237-5.01625-.50447-10.9606-6.68692-12.4485a11.76107,11.76107,0,0,0-7.82276.95086c-5.09461,2.45643-8.20655,7.34346-11.13894,12.04723,0,0-7.006,7.29026-11.89129,10.83335,1.27577.49449,1.11934,2.52776.061,3.3948-1.05843.86709-2.52788.95018-3.87885,1.1667-1.70286.27292-3.63808,1.05189-3.53417,3.17087a3.68182,3.68182,0,0,0,1.38637,2.60386,69.58157,69.58157,0,0,0,25.2,13.26721c2.04919.58465,4.34642,1.05166,6.23049.05607S788.17141,301,786.352,299.89063Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#ffcc01"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "587.328 224.152 522.328 223.152 520.328 208.152 526.328 174.152 577.328 174.152 587.328 224.152",
    fill: "#a0616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.069 538.978 489.031 538.978 483.778 496.405 500.069 496.405 500.069 538.978",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M753.53124,727.62456H745.6157l-1.41289-7.47321-3.61861,7.47321-20.99388,0a4.71923,4.71923,0,0,1-2.68163-8.60272l16.76509-11.57858,0-7.55515,17.63395,1.05251Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "649.348 503.147 640.294 509.46 611.634 477.542 624.997 468.225 649.348 503.147",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M912.7017,685.0241l-6.49294,4.52741-5.43337-5.322,1.30614,8.19983-17.22081,12.00777a4.71923,4.71923,0,0,1-7.12014-5.52283l7.12949-19.0867-4.32129-6.19732,15.06674-9.22266Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M951.17876,730.17064l-702.3575.30731a1.19069,1.19069,0,0,1,0-2.38134l702.3575-.30732a1.19069,1.19069,0,0,1,0,2.38135Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#cacaca"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.93408,
    y: 335.38378,
    width: 215.49825,
    height: 23.7682,
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M452.46268,476.27128l-.72975-2.56026h.164a1.70683,1.70683,0,0,0,0-3.41365,50.78067,50.78067,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38483,7.48643-2.75049,19.92225,0,32.42971h24.74895C455.574,495.06838,457.92981,482.12117,452.46268,476.27128Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.52567,
    cy: 319.97715,
    r: 6.82731,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M471.13413,439.7402l-.72975-2.56027h.16395a1.70682,1.70682,0,0,0,0-3.41364,50.7804,50.7804,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38483,7.48642-2.75048,19.92224,0,32.42971h24.749C474.24542,458.5373,476.60125,445.59009,471.13413,439.7402Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.19711,
    cy: 283.44606,
    r: 6.82731,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M435.13413,439.7402l-.72975-2.56027h.16395a1.70682,1.70682,0,0,0,0-3.41364,50.7804,50.7804,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38483,7.48642-2.75048,19.92224,0,32.42971h24.749C438.24542,458.5373,440.60125,445.59009,435.13413,439.7402Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.19711,
    cy: 283.44606,
    r: 6.82731,
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M419.13413,404.7402l-.72975-2.56027h.16395a1.70682,1.70682,0,0,0,0-3.41364,50.7804,50.7804,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38483,7.48642-2.75048,19.92224,0,32.42971h24.749C422.24542,423.5373,424.60125,410.59009,419.13413,404.7402Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.19711,
    cy: 248.44606,
    r: 6.82731,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M455.13413,404.7402l-.72975-2.56027h.16395a1.70682,1.70682,0,0,0,0-3.41364,50.7804,50.7804,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38483,7.48642-2.75048,19.92224,0,32.42971h24.749C458.24542,423.5373,460.60125,410.59009,455.13413,404.7402Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.19711,
    cy: 248.44606,
    r: 6.82731,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M398.13413,439.7402l-.72975-2.56027h.16395a1.70682,1.70682,0,0,0,0-3.41364,50.7804,50.7804,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38483,7.48642-2.75048,19.92224,0,32.42971h24.749C401.24542,458.5373,403.60125,445.59009,398.13413,439.7402Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.19711,
    cy: 283.44606,
    r: 6.82731,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M727.13413,340.7402l-.72975-2.56027h.16395a1.70682,1.70682,0,0,0,0-3.41364,50.7804,50.7804,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38483,7.48642-2.75048,19.92224,0,32.42971h24.749C730.24542,359.5373,732.60125,346.59009,727.13413,340.7402Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#ccc"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.19711,
    cy: 184.44606,
    r: 6.82731,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M378.58871,476.27128,377.859,473.711h.164a1.70683,1.70683,0,0,0,0-3.41365,50.78067,50.78067,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38482,7.48643-2.75048,19.92225,0,32.42971h24.749C381.7,495.06838,384.05584,482.12117,378.58871,476.27128Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.6517,
    cy: 319.97715,
    r: 6.82731,
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M415.58871,476.27128,414.859,473.711h.164a1.70683,1.70683,0,0,0,0-3.41365,50.78067,50.78067,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38482,7.48643-2.75048,19.92225,0,32.42971h24.749C418.7,495.06838,421.05584,482.12117,415.58871,476.27128Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.6517,
    cy: 319.97715,
    r: 6.82731,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M491.42917,476.27128l-.72974-2.56026h.16395a1.70683,1.70683,0,0,0,0-3.41365,50.78067,50.78067,0,0,0-23.46887,0,1.70586,1.70586,0,0,0-.02027,3.41161l-.694,2.5623c-5.38483,7.48643-2.75049,19.92225,0,32.42971h24.74895C494.54047,495.06838,496.8963,482.12117,491.42917,476.27128Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.49216,
    cy: 319.97715,
    r: 6.82731,
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M833.72127,380.31182l-67.87964-4.5737s-15.728,36.33189-15.47607,41.1339,6.742,3.35558-.003,10.57879-6.745-2.77679-6.745,7.22321-27.27065,232-15.27065,234c21,3,20-1,20-1l32.953-103.24339s59.49733,86.98165,78.047,82.24339,15-11,15-11l-39.74463-80.67467s-5.925-.01089-5.09018-6.66811-4.22193-5.5307-4.22193-5.5307-7.59425-2.36756-4.76876-6.247-4.6745-6.12357-4.6745-6.12357l21.88927-83.7874S853.325,410.44961,833.72127,380.31182Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M827.7337,241.72077l-23.3632,1.18344-7.7994,13.13989S774.34688,257.674,774.34688,275.674s-15.16944,10.167-8.08472,33.08351,8.69889,27.33382,2.3918,30.62515-15.20806,2.58268-7.25757,7.937,10.95049,7.35433,8.95049,9.35433,37.07086-13.73526,59.53543-3.86763c0,0,6.28453-4.757,4.87455-8.94466s-2.17772-2.56848.20615-6.37809S862.64885,267.414,862.64885,267.414s-5.13648-9.5497-16.21923-9.14486S827.7337,241.72077,827.7337,241.72077Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#ffcc01"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M909.70621,464.25541l-41.30915,22.41773-31.7187-58.448a23.5,23.5,0,0,1,41.30915-22.41772Zm-40.50526,19.706,37.79347-20.50984-30.76475-56.69021a21.5,21.5,0,1,0-37.79347,20.50984Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M944.99492,505.97516l-60.85047,33.02246a7.841,7.841,0,0,1-9.19977-1.23848L833.85373,498.316a7.8673,7.8673,0,0,1,1.69536-12.58989l91.265-49.52786a7.8673,7.8673,0,0,1,11.47983,5.44l10.67645,55.94859A7.841,7.841,0,0,1,944.99492,505.97516Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#ffcc01"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 877.70569,
    y: 462.3445,
    width: 7,
    height: 12,
    transform: "translate(-364.32627 307.49732) rotate(-28.48789)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M865.50525,346.96346l-1.78631-62.71433a10.1268,10.1268,0,0,0-10.28016-9.80725h0a10.12681,10.12681,0,0,0-9.94457,10.82063l3.8527,65.08795.67384,39.64855a8.83709,8.83709,0,1,0,10.89991,3.13424Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M869.8456,296.86435h0a2.98618,2.98618,0,0,0,.45665-3.59088,3.874,3.874,0,0,1-.45977-2.31806,3.56228,3.56228,0,0,1,.08892-.45908,5.84263,5.84263,0,0,0-1.06983-5.29511c-1.98065-2.37893-2.93671-5.98032-3.35063-9.19075-.45288-3.51306-.72223-7.10346-2.00293-10.406-1.8475-4.76393-6.26235-9.00956-12.28793-6.97759a11.761,11.761,0,0,0-6.11573,4.96966c-3.0048,4.79168-3.03725,10.58532-3.01529,16.12823l-1.08068-2.19024a44.96651,44.96651,0,0,1-3.21772,17.69146c1.3432-.26062,2.29328,1.54383,1.859,2.84125-.43432,1.29749-1.634,2.15015-2.66229,3.05267-1.29618,1.13762-2.51962,2.8273-1.30354,4.5657a3.68181,3.68181,0,0,0,2.55983,1.46607,69.58136,69.58136,0,0,0,28.39508-2.18551c2.04589-.59607,4.23913-1.42377,5.30395-3.2696S871.97633,296.83475,869.8456,296.86435Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#ffcc01"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M850.15333,210.11612c-1.34,4.96.2,12.77.78,17.4.62,4.95-7.96,9.38-12.87,9.66a6.9892,6.9892,0,0,0-1.3-4.6,11.967,11.967,0,0,1-.96,4.61h-40.97c-5.16-9.71-9.55-22.98-4.81-36.7a14.03972,14.03972,0,0,1,9.7-12.15l22.34-7.15c8.81,0,19.62,1.25,24.49,7.81A24.57544,24.57544,0,0,1,850.15333,210.11612Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#2f2e41"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 565.19654,
    cy: 43.66408,
    r: 23,
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M841.83332,207.18613v5h-19.9a7.15591,7.15591,0,0,0-1.17-5.61,12.19184,12.19184,0,0,1-1.42,5.61c-11.50684,3.40265-21.1651,3.33743-29.07916,0a4.43084,4.43084,0,0,1-4.43085-4.43084v0c0-15.32986,12.08375-28.24712,27.41035-28.56306a27.99692,27.99692,0,0,1,28.58965,27.99392Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M837.91182,173.30488c-2.3714-1.10943-5.04126-1.57959-6.91223-3.78283l.70624,3.73236a17.626,17.626,0,0,0-12.55036-1.568,6.73025,6.73025,0,0,0-3.31354,1.71942,4.95654,4.95654,0,0,0-1.31311,4.07953,4.6413,4.6413,0,0,0,2.07727,3.1203,8.96245,8.96245,0,0,0,3.16559,1.07776q6.94309,1.41138,13.88611,2.8227a10.59135,10.59135,0,0,0,5.31964.1698,5.21978,5.21978,0,0,0,3.514-4.51587C842.755,176.97328,840.28322,174.41426,837.91182,173.30488Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M462.77642,348.18741,353.14828,383.56366a3.87593,3.87593,0,0,1-4.87329-2.49545l-13.86646-42.971a3.87594,3.87594,0,0,1,2.49545-4.87329l109.62814-35.37625a3.87594,3.87594,0,0,1,4.87329,2.49545l13.86646,42.971A3.87594,3.87594,0,0,1,462.77642,348.18741Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#f2f2f2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M436.45041,354.08811l-66.65863,21.51028a19.70932,19.70932,0,0,1-24.78164-12.68985l-2.6353-8.16657a19.70945,19.70945,0,0,1,12.68981-24.78178l74.8252-24.14558a19.70945,19.70945,0,0,1,24.78168,12.69A28.30037,28.30037,0,0,1,436.45041,354.08811Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M408.49755,326.29987,364.4354,340.51843a.99845.99845,0,1,1-.61324-1.90041l44.06215-14.21855a.99845.99845,0,0,1,.61324,1.9004Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M434.07406,329.24023l-66.36718,21.41623a.99845.99845,0,1,1-.61325-1.9004l66.36719-21.41624a.99845.99845,0,0,1,.61324,1.90041Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M437.34554,339.37826,370.97835,360.7945a.99845.99845,0,1,1-.61324-1.90041l66.36718-21.41623a.99845.99845,0,0,1,.61325,1.9004Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M437.34554,339.37826,370.97835,360.7945a.99845.99845,0,1,1-.61324-1.90041l66.36718-21.41623a.99845.99845,0,0,1,.61325,1.9004Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#e6e6e6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.15224,
    cy: 134.86954,
    r: 11.55118,
    fill: "#ffcc01"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M442.38282,309.02525a.99833.99833,0,0,1-.79882-.39953l-2.44919-3.26565a.9986.9986,0,1,1,1.59779-1.19827l1.60235,2.1363,4.11542-6.173a.99864.99864,0,0,1,1.66184,1.10789l-4.89839,7.34759a.999.999,0,0,1-.80321.44439Z",
    transform: "translate(-247.63678 -169.52205)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoneShopping);
export default __webpack_public_path__ + "static/media/gone_shopping.b3b1d5577ead09159825a6b68323762f.svg";
export { ForwardRef as ReactComponent };